import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: 'initial !important',
		},
		bgSection: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			height: '100%',
			bottom: 0,
			overflow: 'hidden',
			zIndex: 1,

			[theme.breakpoints.only('sm')]: {
				position: 'initial',
				marginRight: theme.spacing(-3),
				marginLeft: theme.spacing(-3),
			},
			[theme.breakpoints.down('xs')]: {
				position: 'initial',
				marginRight: theme.spacing(-2),
				marginLeft: theme.spacing(-2),
			},
		},
		bgContainer: {
			height: '100%',

			[theme.breakpoints.down('sm')]: {
				padding: 0,
			},
		},
		bgGrid: {
			height: '100%',
		},
		background: {
			backgroundColor: 'lightgray',
			height: theme.spacing(50),
			width: '100%',
			overflow: 'hidden',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',

			[theme.breakpoints.up('md')]: {
				height: '100%',
			},
		},
		withVideo: {
			cursor: 'pointer',
		},
		icon: {
			fontSize: '3.4rem',
			color: 'white',
		},
		content: {
			position: 'relative',
			zIndex: 2,

			[theme.breakpoints.down('sm')]: {
				marginTop: ({ metaData }) => (metaData.mobileVideoPosition?.isLeftAlignment ? theme.spacing(7) : null),
				marginBottom: ({ metaData }) =>
					metaData.mobileVideoPosition?.isRightAlignment ? theme.spacing(7) : null,
			},
		},
		modal: {
			backgroundColor: 'transparent',
			boxShadow: 'none',
			width: '100%',
			overflowY: 'visible',
		},

		text: {
			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => `${metaData.mobileAlignment?.metaValue} !important`,
				},
			},
		},

		buttonWrap: {
			[theme.breakpoints.down('sm')]: {
				display: 'flex',
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment() || null,
			},
		},
		button: {
			width: 'auto',
			marginTop: theme.spacing(3.5),

			[theme.breakpoints.down('sm')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
				marginTop: 0,
			},
		},
	}),
	{ name: 'Video-Video2' },
)

export default useStyles
